import type { Chapter, Section } from '../types'

/**
 * 章节配置
 * 后续可改为从 JSON 加载
 */
export const chapters: Chapter[] = [
  {
    id: 1,
    title: '先活下来',
    description: '四不原则、防守哲学、止损纪律、交易心理、择时入门',
    sections: [
      {
        id: 's1',
        title: '四不原则',
        cardIds: ['ch1-s1-c1', 'ch1-s1-c2', 'ch1-s1-c3', 'ch1-s1-c4', 'ch1-s1-c5'],
        learningObjectives: [
          '理解四不原则：不追、不动、不慌、不乱摸',
          '能在实际场景中识别违反四不原则的行为',
        ],
      },
      {
        id: 's2',
        title: '防守哲学',
        cardIds: ['ch1-s2-c1', 'ch1-s2-c2', 'ch1-s2-c3', 'ch1-s2-c4'],
        learningObjectives: [
          '理解先防守后进攻的理念',
          '掌握空仓策略的适用场景',
        ],
      },
      {
        id: 's3',
        title: '止损纪律',
        cardIds: ['ch1-s3-c1', 'ch1-s3-c2', 'ch1-s3-c3', 'ch1-s3-c4', 'ch1-s3-c5'],
        learningObjectives: [
          '理解止损的定义和重要性',
          '能在场景中正确执行止损',
        ],
      },
      {
        id: 's4',
        title: '交易心理',
        cardIds: ['ch1-s4-c1', 'ch1-s4-c2', 'ch1-s4-c3', 'ch1-s4-c4'],
        learningObjectives: [
          '识别常见的交易心理陷阱',
          '理解追高、恐慌、过度交易的危害',
        ],
      },
      {
        id: 's5',
        title: '择时入门',
        cardIds: ['ch1-s5-c1', 'ch1-s5-c2', 'ch1-s5-c3', 'ch1-s5-c4'],
        learningObjectives: [
          '理解红/黄/灰三种市场环境',
          '掌握攻/守/看三种策略选择',
        ],
      },
    ],
  },
  {
    id: 2,
    title: '买卖信号识别',
    description: '白线黄线、B1 建仓波、B2 突破、J 值超买超卖、N 型结构',
    prerequisites: [1],
    sections: [
      {
        id: 's1',
        title: '白线黄线系统',
        cardIds: ['ch2-s1-c1', 'ch2-s1-c2', 'ch2-s1-c3', 'ch2-s1-c4', 'ch2-s1-c5'],
        learningObjectives: [
          '理解白线与黄线的画法与意义',
          '掌握跌破/站上白黄线的应对动作',
        ],
      },
      {
        id: 's2',
        title: 'B1 建仓波',
        cardIds: ['ch2-s2-c1', 'ch2-s2-c2', 'ch2-s2-c3', 'ch2-s2-c4', 'ch2-s2-c5'],
        learningObjectives: [
          '识别建仓波三段式结构',
          '掌握 B1 配套买点（J 值、量能）',
        ],
      },
      {
        id: 's3',
        title: 'B2 突破与假突破',
        cardIds: ['ch2-s3-c1', 'ch2-s3-c2', 'ch2-s3-c3', 'ch2-s3-c4', 'ch2-s3-c5'],
        learningObjectives: [
          '识别真突破与假 B2 陷阱',
          '掌握突破后的回踩买入策略',
        ],
      },
      {
        id: 's4',
        title: 'J 值与超买超卖',
        cardIds: ['ch2-s4-c1', 'ch2-s4-c2', 'ch2-s4-c3', 'ch2-s4-c4', 'ch2-s4-c5'],
        learningObjectives: [
          '理解 KDJ / J 值的含义',
          '掌握 J 值与其他信号的配套使用',
        ],
      },
      {
        id: 's5',
        title: 'N 型结构',
        cardIds: ['ch2-s5-c1', 'ch2-s5-c2', 'ch2-s5-c3', 'ch2-s5-c4', 'ch2-s5-c5'],
        learningObjectives: [
          '识别健康的 N 型上升结构',
          '掌握 N 型回调的买点节奏',
        ],
      },
    ],
  },
  {
    id: 3,
    title: '仓位管理',
    description: '三分法建仓、加减仓节奏、止损与仓位联动、满仓陷阱、市况仓位策略',
    prerequisites: [1, 2],
    sections: [
      {
        id: 's1',
        title: '三分法建仓',
        cardIds: [
          'ch3-s1-c1', 'ch3-s1-c2', 'ch3-s1-c3', 'ch3-s1-c4', 'ch3-s1-c5',
        ],
        learningObjectives: [
          '理解底仓/加仓/机动仓的三分法',
          '掌握单票仓位上限铁律（≤ 30%）',
        ],
      },
      {
        id: 's2',
        title: '加减仓节奏',
        cardIds: [
          'ch3-s2-c1', 'ch3-s2-c2', 'ch3-s2-c3', 'ch3-s2-c4', 'ch3-s2-c5',
        ],
        learningObjectives: [
          '掌握金字塔加仓法',
          '掌握倒金字塔减仓法',
        ],
      },
      {
        id: 's3',
        title: '止损与仓位联动',
        cardIds: [
          'ch3-s3-c1', 'ch3-s3-c2', 'ch3-s3-c3', 'ch3-s3-c4', 'ch3-s3-c5',
        ],
        learningObjectives: [
          '理解止损幅度决定仓位大小的逻辑',
          '掌握回本率的数学关系',
        ],
      },
      {
        id: 's4',
        title: '满仓的陷阱',
        cardIds: [
          'ch3-s4-c1', 'ch3-s4-c2', 'ch3-s4-c3', 'ch3-s4-c4', 'ch3-s4-c5',
        ],
        learningObjectives: [
          '理解满仓 = 没有退路',
          '掌握永远留 30% 现金的铁律',
        ],
      },
      {
        id: 's5',
        title: '不同市况的仓位策略',
        cardIds: [
          'ch3-s5-c1', 'ch3-s5-c2', 'ch3-s5-c3', 'ch3-s5-c4', 'ch3-s5-c5',
        ],
        learningObjectives: [
          '掌握红/黄/灰三种市况的仓位上限',
          '能在不同市况间切换仓位策略',
        ],
      },
    ],
  },
  {
    id: 4,
    title: '复盘与行为统计',
    description: '复盘姿势、交易行为分析、行为偏差、用数据改进系统',
    prerequisites: [1, 2, 3],
    sections: [
      {
        id: 's1',
        title: '复盘的正确姿势',
        cardIds: [
          'ch4-s1-c1', 'ch4-s1-c2', 'ch4-s1-c3', 'ch4-s1-c4', 'ch4-s1-c5',
        ],
        learningObjectives: [
          '掌握每日复盘的标准流程',
          '理解复盘模板的关键要素',
        ],
      },
      {
        id: 's2',
        title: '交易行为分析',
        cardIds: [
          'ch4-s2-c1', 'ch4-s2-c2', 'ch4-s2-c3', 'ch4-s2-c4', 'ch4-s2-c5',
        ],
        learningObjectives: [
          '学会统计追高次数、止损执行率',
          '用数据量化自己的交易习惯',
        ],
      },
      {
        id: 's3',
        title: '常见行为偏差',
        cardIds: [
          'ch4-s3-c1', 'ch4-s3-c2', 'ch4-s3-c3', 'ch4-s3-c4', 'ch4-s3-c5',
        ],
        learningObjectives: [
          '识别过度交易、锚定效应、确认偏误',
          '能在复盘中发现自身的认知偏差',
        ],
      },
      {
        id: 's4',
        title: '用数据改进系统',
        cardIds: [
          'ch4-s4-c1', 'ch4-s4-c2', 'ch4-s4-c3', 'ch4-s4-c4', 'ch4-s4-c5',
        ],
        learningObjectives: [
          '从复盘中提炼可执行的规则',
          '形成个人交易系统的正反馈循环',
        ],
      },
    ],
  },
  {
    id: 5,
    title: '行业与题材识别',
    description: '行业轮动、题材生命周期、龙头辨识、板块联动',
    prerequisites: [1, 2, 3, 4],
    sections: [
      {
        id: 's1',
        title: '行业轮动逻辑',
        cardIds: [
          'ch5-s1-c1', 'ch5-s1-c2', 'ch5-s1-c3', 'ch5-s1-c4', 'ch5-s1-c5',
        ],
        learningObjectives: [
          '理解经济周期与行业板块的对应关系',
          '掌握行业轮动的节奏',
        ],
      },
      {
        id: 's2',
        title: '题材的生命周期',
        cardIds: [
          'ch5-s2-c1', 'ch5-s2-c2', 'ch5-s2-c3', 'ch5-s2-c4', 'ch5-s2-c5',
        ],
        learningObjectives: [
          '识别题材启动→发酵→高潮→退潮四阶段',
          '掌握每个阶段的操作策略',
        ],
      },
      {
        id: 's3',
        title: '龙头辨识',
        cardIds: [
          'ch5-s3-c1', 'ch5-s3-c2', 'ch5-s3-c3', 'ch5-s3-c4', 'ch5-s3-c5',
        ],
        learningObjectives: [
          '理解龙头的定义和特征',
          '掌握龙头见顶的识别信号',
        ],
      },
      {
        id: 's4',
        title: '板块联动的陷阱',
        cardIds: [
          'ch5-s4-c1', 'ch5-s4-c2', 'ch5-s4-c3', 'ch5-s4-c4', 'ch5-s4-c5',
        ],
        learningObjectives: [
          '区分真联动与假联动',
          '理解板块高潮后的风险信号',
        ],
      },
    ],
  },
  {
    id: 6,
    title: '实战战法',
    description: '少妇战法、嘀嘀战法、补票战法、量比战法、单针下30',
    prerequisites: [1, 2, 3, 4, 5],
    sections: [
      {
        id: 's1',
        title: '少妇战法',
        cardIds: [
          'ch6-s1-c1', 'ch6-s1-c2', 'ch6-s1-c3', 'ch6-s1-c4', 'ch6-s1-c5',
        ],
        learningObjectives: [
          '掌握少妇战法六步SOP',
          '理解极度风险厌恶的交易哲学',
        ],
      },
      {
        id: 's2',
        title: '嘀嘀战法',
        cardIds: [
          'ch6-s2-c1', 'ch6-s2-c2', 'ch6-s2-c3', 'ch6-s2-c4', 'ch6-s2-c5',
        ],
        learningObjectives: [
          '掌握嘀嘀战法的加减法纪律',
          '理解分批建仓与减仓的节奏',
        ],
      },
      {
        id: 's3',
        title: '补票战法',
        cardIds: [
          'ch6-s3-c1', 'ch6-s3-c2', 'ch6-s3-c3', 'ch6-s3-c4', 'ch6-s3-c5',
        ],
        learningObjectives: [
          '理解补票战法的适用场景',
          '掌握补票仓位与止损纪律',
        ],
      },
      {
        id: 's4',
        title: '量比战法',
        cardIds: [
          'ch6-s4-c1', 'ch6-s4-c2', 'ch6-s4-c3', 'ch6-s4-c4', 'ch6-s4-c5',
        ],
        learningObjectives: [
          '掌握量比指标的盘中动态识别',
          '理解量比与资金进出的关系',
        ],
      },
      {
        id: 's5',
        title: '单针下30',
        cardIds: [
          'ch6-s5-c1', 'ch6-s5-c2', 'ch6-s5-c3', 'ch6-s5-c4', 'ch6-s5-c5',
        ],
        learningObjectives: [
          '理解单针下30的量化时代迭代逻辑',
          '掌握红线>85+白线<30的双条件判断',
        ],
      },
    ],
  },
  {
    id: 7,
    title: '主力与筹码',
    description: '主力出货识别、五类资金画像、筹码三段论、穿越火线',
    prerequisites: [1, 2, 3, 4, 5, 6],
    sections: [
      {
        id: 's1',
        title: '主力出货五种经典方式',
        cardIds: [
          'ch7-s1-c1', 'ch7-s1-c2', 'ch7-s1-c3', 'ch7-s1-c4', 'ch7-s1-c5',
        ],
        learningObjectives: [
          '识别S1~S5五种出货信号',
          '掌握出货识别后的执行纪律',
        ],
      },
      {
        id: 's2',
        title: '五类资金画像',
        cardIds: [
          'ch7-s2-c1', 'ch7-s2-c2', 'ch7-s2-c3', 'ch7-s2-c4', 'ch7-s2-c5',
        ],
        learningObjectives: [
          '理解某队/社保/险资/公募/公司自有五类资金的KPI与行为',
          '判断当下盘面由哪类资金主导',
        ],
      },
      {
        id: 's3',
        title: '筹码三段论',
        cardIds: [
          'ch7-s3-c1', 'ch7-s3-c2', 'ch7-s3-c3', 'ch7-s3-c4', 'ch7-s3-c5',
        ],
        learningObjectives: [
          '掌握筹码峰转移+股东户数+33年循环三段框架',
          '理解「主力筹码不死只换主人」的底层逻辑',
        ],
      },
      {
        id: 's4',
        title: '穿越火线',
        cardIds: [
          'ch7-s4-c1', 'ch7-s4-c2', 'ch7-s4-c3', 'ch7-s4-c4', 'ch7-s4-c5',
        ],
        learningObjectives: [
          '掌握上压下托震荡期的生存法则',
          '理解三十度斜率波段操作与建仓波法则',
        ],
      },
    ],
  },
  {
    id: 8,
    title: '技术工具箱',
    description: 'MACD 三大用法与共振、顶底背离体系、趋势线与砖形图、量价关系、有序与无序',
    prerequisites: [1, 2],
    sections: [
      {
        id: 's1',
        title: 'MACD 体系',
        cardIds: [
          'ch8-s1-c1', 'ch8-s1-c2', 'ch8-s1-c3', 'ch8-s1-c4',
          'ch8-s1-c5', 'ch8-s1-c6', 'ch8-s1-c7', 'ch8-s1-c8',
        ],
        learningObjectives: [
          '掌握 MACD 三大用法：金叉死叉、零轴、背离',
          '理解 MACD 共振战法的判断条件与应用场景',
        ],
      },
      {
        id: 's2',
        title: '顶底背离体系',
        cardIds: [
          'ch8-s2-c1', 'ch8-s2-c2', 'ch8-s2-c3', 'ch8-s2-c4',
          'ch8-s2-c5', 'ch8-s2-c6', 'ch8-s2-c7', 'ch8-s2-c8',
        ],
        learningObjectives: [
          '识别顶背离与底背离的标准形态',
          '掌握背离确认后的执行纪律',
        ],
      },
      {
        id: 's3',
        title: '趋势线与砖形图',
        cardIds: [
          'ch8-s3-c1', 'ch8-s3-c2', 'ch8-s3-c3', 'ch8-s3-c4',
          'ch8-s3-c5', 'ch8-s3-c6', 'ch8-s3-c7', 'ch8-s3-c8',
        ],
        learningObjectives: [
          '掌握知行趋势线的画法与应用',
          '理解砖形图的特点与适用场景',
        ],
      },
      {
        id: 's4',
        title: '量价与活跃市值',
        cardIds: [
          'ch8-s4-c1', 'ch8-s4-c2', 'ch8-s4-c3', 'ch8-s4-c4',
          'ch8-s4-c5', 'ch8-s4-c6', 'ch8-s4-c7', 'ch8-s4-c8',
        ],
        learningObjectives: [
          '掌握量价关系四大类的识别',
          '理解活跃市值的含义与盘面判断作用',
        ],
      },
      {
        id: 's5',
        title: '有序与无序',
        cardIds: [
          'ch8-s5-c1', 'ch8-s5-c2', 'ch8-s5-c3',
          'ch8-s5-c4', 'ch8-s5-c5', 'ch8-s5-c6',
        ],
        learningObjectives: [
          '区分有序趋势与无序震荡',
          '建立「无序不做」的交易纪律',
        ],
      },
    ],
  },
  {
    id: 9,
    title: '买卖信号攻防',
    description: 'B3 买点、超级 B1、SB1 假摔、B2 战法、两个 30% 原则、三波理论、S1 信号、DSZ 战法、逃顶艺术、娜娜图、双枪战法、十张死亡 K 线图',
    prerequisites: [1, 2, 8],
    sections: [
      {
        id: 's1',
        title: 'B 买点族（一）',
        cardIds: [
          'ch9-s1-c1', 'ch9-s1-c2', 'ch9-s1-c3', 'ch9-s1-c4', 'ch9-s1-c5',
          'ch9-s1-c6', 'ch9-s1-c7', 'ch9-s1-c8', 'ch9-s1-c9', 'ch9-s1-c10',
        ],
        learningObjectives: [
          '识别 B3 买点的结构与进场条件',
          '掌握超级 B1 与 SB1 假摔战法的识别要点',
        ],
      },
      {
        id: 's2',
        title: 'B 买点族（二）',
        cardIds: [
          'ch9-s2-c1', 'ch9-s2-c2', 'ch9-s2-c3', 'ch9-s2-c4', 'ch9-s2-c5',
          'ch9-s2-c6', 'ch9-s2-c7', 'ch9-s2-c8', 'ch9-s2-c9', 'ch9-s2-c10',
        ],
        learningObjectives: [
          '掌握 B2 战法的操作要点',
          '理解两个 30% 原则与三波理论的节奏判断',
        ],
      },
      {
        id: 's3',
        title: 'S 卖点与逃顶',
        cardIds: [
          'ch9-s3-c1', 'ch9-s3-c2', 'ch9-s3-c3', 'ch9-s3-c4', 'ch9-s3-c5',
          'ch9-s3-c6', 'ch9-s3-c7', 'ch9-s3-c8', 'ch9-s3-c9', 'ch9-s3-c10',
        ],
        learningObjectives: [
          '识别 S1 信号的卖出纪律',
          '掌握 DSZ 战法与逃顶艺术的执行标准',
        ],
      },
      {
        id: 's4',
        title: '图形与警示',
        cardIds: [
          'ch9-s4-c1', 'ch9-s4-c2', 'ch9-s4-c3', 'ch9-s4-c4', 'ch9-s4-c5',
          'ch9-s4-c6', 'ch9-s4-c7', 'ch9-s4-c8', 'ch9-s4-c9', 'ch9-s4-c10',
        ],
        learningObjectives: [
          '认识娜娜图的缩量形态特征',
          '识别双枪战法与十张死亡 K 线图的风险警示',
        ],
      },
    ],
  },
  {
    id: 10,
    title: '十八般战法',
    description: '双线战法、对称 VA 战法、转折点战法、呼吸结构、扭一扭、坑口战法、异动选股法、三个黄金定式、四块砖交易体系、三换三、单针下 20',
    prerequisites: [1, 2, 8, 9],
    sections: [
      {
        id: 's1',
        title: '趋势战法',
        cardIds: [
          'ch10-s1-c1', 'ch10-s1-c2', 'ch10-s1-c3', 'ch10-s1-c4', 'ch10-s1-c5',
          'ch10-s1-c6', 'ch10-s1-c7', 'ch10-s1-c8', 'ch10-s1-c9', 'ch10-s1-c10',
        ],
        learningObjectives: [
          '掌握双线战法的进出场要点',
          '理解对称 VA 战法与转折点战法的判断条件',
        ],
      },
      {
        id: 's2',
        title: '结构战法',
        cardIds: [
          'ch10-s2-c1', 'ch10-s2-c2', 'ch10-s2-c3', 'ch10-s2-c4', 'ch10-s2-c5',
          'ch10-s2-c6', 'ch10-s2-c7', 'ch10-s2-c8', 'ch10-s2-c9', 'ch10-s2-c10',
        ],
        learningObjectives: [
          '识别呼吸结构与扭一扭形态',
          '掌握坑口战法的适用场景与纪律',
        ],
      },
      {
        id: 's3',
        title: '选股与定式',
        cardIds: [
          'ch10-s3-c1', 'ch10-s3-c2', 'ch10-s3-c3', 'ch10-s3-c4', 'ch10-s3-c5',
          'ch10-s3-c6', 'ch10-s3-c7', 'ch10-s3-c8', 'ch10-s3-c9', 'ch10-s3-c10',
        ],
        learningObjectives: [
          '掌握异动选股法的筛选标准',
          '理解三个黄金定式与四块砖交易体系',
        ],
      },
      {
        id: 's4',
        title: '检查与换仓',
        cardIds: [
          'ch10-s4-c1', 'ch10-s4-c2', 'ch10-s4-c3', 'ch10-s4-c4', 'ch10-s4-c5',
          'ch10-s4-c6', 'ch10-s4-c7', 'ch10-s4-c8', 'ch10-s4-c9', 'ch10-s4-c10',
        ],
        learningObjectives: [
          '落实少妇战法 1.3 每日持股检查手册',
          '掌握三换三与单针下 20 的换仓纪律',
        ],
      },
    ],
  },
  {
    id: 11,
    title: '仓位调配',
    description: '半仓放飞策略、交易松紧手、去弱留强、新曼城阵容、开超市策略',
    prerequisites: [1, 3],
    sections: [
      {
        id: 's1',
        title: '仓位弹性',
        cardIds: [
          'ch11-s1-c1', 'ch11-s1-c2', 'ch11-s1-c3', 'ch11-s1-c4', 'ch11-s1-c5',
          'ch11-s1-c6', 'ch11-s1-c7', 'ch11-s1-c8', 'ch11-s1-c9', 'ch11-s1-c10',
        ],
        learningObjectives: [
          '掌握半仓放飞策略与交易松紧手的切换节奏',
          '理解去弱留强的执行标准',
        ],
      },
      {
        id: 's2',
        title: '组合配置',
        cardIds: [
          'ch11-s2-c1', 'ch11-s2-c2', 'ch11-s2-c3', 'ch11-s2-c4',
          'ch11-s2-c5', 'ch11-s2-c6', 'ch11-s2-c7', 'ch11-s2-c8',
        ],
        learningObjectives: [
          '理解新曼城阵容的组合配置逻辑',
          '掌握开超市策略的适用场景与风险',
        ],
      },
      {
        id: 's3',
        title: '去弱留强',
        cardIds: [
          'ch11-s3-c1', 'ch11-s3-c2', 'ch11-s3-c3',
        ],
        learningObjectives: [
          '掌握去弱留强的判断标准与执行节奏',
          '理解弱势持仓的退出时机',
        ],
      },
      {
        id: 's4',
        title: '组合配置（拓展）',
        cardIds: [
          'ch11-s4-c1', 'ch11-s4-c2', 'ch11-s4-c3', 'ch11-s4-c4',
          'ch11-s4-c5', 'ch11-s4-c6', 'ch11-s4-c7', 'ch11-s4-c8',
        ],
        learningObjectives: [
          '理解组合配置的多种打法',
          '掌握不同市况下的仓位搭配',
        ],
      },
    ],
  },
  {
    id: 12,
    title: '筹码与大势',
    description: '筹码战争、AI 控盘指数论、A 股博弈本质、牛市策略、牛市 ETF 躺平策略、指数贡献策略',
    prerequisites: [1, 2, 3, 7],
    sections: [
      {
        id: 's1',
        title: '筹码博弈',
        cardIds: [
          'ch12-s1-c1', 'ch12-s1-c2', 'ch12-s1-c3', 'ch12-s1-c4', 'ch12-s1-c5',
          'ch12-s1-c6', 'ch12-s1-c7', 'ch12-s1-c8', 'ch12-s1-c9', 'ch12-s1-c10',
        ],
        learningObjectives: [
          '理解筹码战争中主力与散户的博弈结构',
          '掌握 AI 控盘指数论与 A 股博弈本质的判断要点',
        ],
      },
      {
        id: 's2',
        title: '牛市 ETF 躺平策略',
        cardIds: [
          'ch12-s2-c1', 'ch12-s2-c2', 'ch12-s2-c3', 'ch12-s2-c4', 'ch12-s2-c5',
          'ch12-s2-c6', 'ch12-s2-c7', 'ch12-s2-c8', 'ch12-s2-c9', 'ch12-s2-c10',
        ],
        learningObjectives: [
          '掌握牛市策略的仓位与节奏',
          '理解牛市 ETF 躺平策略与指数贡献策略的执行方式',
        ],
      },
      {
        id: 's3',
        title: '牛市与指数策略',
        cardIds: [
          'ch12-s3-c1', 'ch12-s3-c2', 'ch12-s3-c3', 'ch12-s3-c4', 'ch12-s3-c5',
          'ch12-s3-c6', 'ch12-s3-c7', 'ch12-s3-c8', 'ch12-s3-c9', 'ch12-s3-c10',
        ],
        learningObjectives: [
          '建立牛市判断的指数化框架',
          '掌握指数贡献策略在不同行情段的应用',
        ],
      },
    ],
  },
  {
    id: 13,
    title: '体系与心法',
    description: '框架式交易、七层应对、周期与人性、择时大于选股、三种波段路径、击穿对手盘、分歧与一致、价投真相与实操法则',
    prerequisites: [1, 4],
    sections: [
      {
        id: 's1',
        title: '体系框架',
        cardIds: [
          'ch13-s1-c1', 'ch13-s1-c2', 'ch13-s1-c3', 'ch13-s1-c4',
          'ch13-s1-c5', 'ch13-s1-c6', 'ch13-s1-c7', 'ch13-s1-c8',
        ],
        learningObjectives: [
          '理解框架式交易的构成与运行逻辑',
          '掌握七层应对的决策路径',
        ],
      },
      {
        id: 's2',
        title: '周期与择时',
        cardIds: [
          'ch13-s2-c1', 'ch13-s2-c2', 'ch13-s2-c3', 'ch13-s2-c4', 'ch13-s2-c5',
          'ch13-s2-c6', 'ch13-s2-c7', 'ch13-s2-c8', 'ch13-s2-c9', 'ch13-s2-c10',
        ],
        learningObjectives: [
          '理解周期与人性的相互作用',
          '掌握择时大于选股的判断方法与三种波段路径',
        ],
      },
      {
        id: 's3',
        title: '博弈与心性',
        cardIds: [
          'ch13-s3-c1', 'ch13-s3-c2', 'ch13-s3-c3', 'ch13-s3-c4', 'ch13-s3-c5',
          'ch13-s3-c6', 'ch13-s3-c7', 'ch13-s3-c8', 'ch13-s3-c9', 'ch13-s3-c10',
        ],
        learningObjectives: [
          '理解击穿对手盘的博弈逻辑',
          '掌握分歧与一致的节奏判断和价投实操法则',
        ],
      },
    ],
  },
  {
    id: 14,
    title: '作战手册',
    description: '短线交易操作手册、长线交易操作手册',
    prerequisites: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    sections: [
      {
        id: 's1',
        title: '短线交易操作手册',
        cardIds: [
          'ch14-s1-c1', 'ch14-s1-c2', 'ch14-s1-c3', 'ch14-s1-c4', 'ch14-s1-c5',
        ],
        learningObjectives: [
          '掌握短线操作手册的每日流程',
          '能在各场景中执行对应手册纪律',
        ],
      },
      {
        id: 's2',
        title: '长线交易操作手册',
        cardIds: [
          'ch14-s2-c1', 'ch14-s2-c2', 'ch14-s2-c3', 'ch14-s2-c4', 'ch14-s2-c5',
        ],
        learningObjectives: [
          '掌握长线操作手册的持仓流程',
          '理解长线交易的加减仓与换股标准',
        ],
      },
      {
        id: 's3',
        title: '盘中执行与仓位纪律',
        cardIds: [
          'ch14-s3-c1', 'ch14-s3-c2', 'ch14-s3-c3', 'ch14-s3-c4', 'ch14-s3-c5',
        ],
        learningObjectives: [
          '掌握盘中执行的关键铁律',
          '理解开盘 30 分钟的风险与机会',
        ],
      },
      {
        id: 's4',
        title: '止盈复盘与系统升级',
        cardIds: [
          'ch14-s4-c1', 'ch14-s4-c2', 'ch14-s4-c3', 'ch14-s4-c4', 'ch14-s4-c5',
        ],
        learningObjectives: [
          '建立止盈与复盘的标准化流程',
          '通过复盘持续迭代交易系统',
        ],
      },
    ],
  },
]

/**
 * 获取章节
 */
export function getChapter(chapterId: number): Chapter | undefined {
  return chapters.find(c => c.id === chapterId)
}

/**
 * 获取小节
 */
export function getSection(
  chapterId: number,
  sectionId: string
): Section | undefined {
  const chapter = getChapter(chapterId)
  return chapter?.sections.find(s => s.id === sectionId)
}

/**
 * 获取所有小节 ID
 */
export function getSectionIds(chapterId: number): string[] {
  const chapter = getChapter(chapterId)
  return chapter?.sections.map(s => s.id) ?? []
}

/**
 * 计算章节里所有卡片的 ID 列表
 */
export function getChapterCardIds(chapterId: number): string[] {
  const chapter = getChapter(chapterId)
  return chapter?.sections.flatMap(s => s.cardIds) ?? []
}

/**
 * 检查章节是否完成（所有卡片 mastery >= 60）
 */
export function isChapterCompleted(
  chapterId: number,
  progressMap: Record<string, { mastery: number }>
): boolean {
  const cardIds = getChapterCardIds(chapterId)
  if (cardIds.length === 0) return false
  return cardIds.every(id => (progressMap[id]?.mastery ?? 0) >= 60)
}

/**
 * 检查章节是否解锁（前置章节全部完成 或 无前置）
 */
export function isChapterUnlocked(
  chapterId: number,
  progressMap: Record<string, { mastery: number }>
): boolean {
  const chapter = getChapter(chapterId)
  if (!chapter) return false
  if (!chapter.prerequisites || chapter.prerequisites.length === 0) return true
  return chapter.prerequisites.every(prereqId =>
    isChapterCompleted(prereqId, progressMap)
  )
}